/* import broken from "../../../Assets/Images/questions/questionThree/broken.svg";
import efficient from "../../../Assets/Images/questions/questionThree/efficient.svg";
import old from "../../../Assets/Images/questions/questionThree/old.svg";
import renovation from "../../../Assets/Images/questions/questionThree/renovation.svg"; */

export const currentWorkingData = [
  {
    title: "Broken Boiler",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170246/AquaHeat/Quote%20Icons/question%203/broken_xdekjg.svg",
  },
  {
    title: "Replacing Old Boiler",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170246/AquaHeat/Quote%20Icons/question%203/old_zkxwnl.svg",
  },
  {
    title: "Renovating",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170246/AquaHeat/Quote%20Icons/question%203/renovation_hyg7iz.svg",
  },
  {
    title: "Lower Bills",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170246/AquaHeat/Quote%20Icons/question%203/efficient_lkfucl.svg",
  },
];
